import React from 'react'

import useMediaQuery from 'hooks/useMediaQuery'
import styles from './styles'

const Divider = () => {
  const { isMobile } = useMediaQuery()

  return (
    <div style={{ ...styles.divider, ...(isMobile && styles.dividerMobile) }} />
  )
}

export default Divider
